/**
 * Thin indeterminate loading bar — used across all screens.
 * Drop-in: <LoadingBar /> renders a 2px animated blue bar.
 *
 * Variants:
 *  - "inline"  (default) — relative, full-width, rounded pill
 *  - "fixed"   — fixed to top of viewport
 *  - "absolute"— absolute-positioned at bottom of parent (parent needs overflow-hidden + relative)
 */
export default function LoadingBar({
  variant = "inline",
}: {
  variant?: "inline" | "fixed" | "absolute";
}) {
  if (variant === "fixed") {
    return (
      <div className="fixed top-0 left-0 right-0 z-50 h-[2px] bg-blue-100 overflow-hidden">
        <div
          className="absolute h-full bg-blue-400 rounded-full"
          style={{ width: "45%", animation: "loading-bar 1.4s ease-in-out infinite" }}
        />
      </div>
    );
  }

  if (variant === "absolute") {
    return (
      <div className="absolute bottom-0 left-0 right-0 h-[2px]">
        <div
          className="absolute h-full bg-blue-400 rounded-full"
          style={{ animation: "loading-bar 1.4s ease-in-out infinite" }}
        />
      </div>
    );
  }

  // inline (default)
  return (
    <div className="w-full h-[2px] bg-neutral-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-blue-400 rounded-full"
        style={{ animation: "loading-bar 2s ease-in-out infinite" }}
      />
    </div>
  );
}
